import React, {Component} from "react";
import PopupClose from "../buttons/popup-close";
import {rd} from "../../../vars/rd";
import CategoryTheme from "../buttons/category.theme";

class ThemeFilter extends Component {
    constructor(props) {
        super(props);

        this.callback = props.callback;
        this.callbackLoaded = props.callbackLoaded;
        this.state = {
            data: (props.data || []),
            close: false
        }
    }

    componentDidMount() {
        this.mounted = true;
        if(this.callbackLoaded) this.callbackLoaded.call(null, this);
    }

    componentWillUnmount() {
        this.mounted = false;
        this.callback = null;
        this.callbackLoaded = null;
    }

    /**
     * 창닫기
     */
    close(reset=false) {
        const data = reset ? [] : (this.state.data || []);
        if(this.callback) this.callback(data);
        if (this.mounted) {
            this.setState({ close: true });
        }
    }

    /**
     * @returns {DaoCategory[]}
     */
    get categories() {
        return rd.category.theme || [];
    }

    /**
     *
     * @param category {DaoCategory}
     * @param selected {boolean}
     */
    changeCategory = (category, selected) => {
        if(category) {
            const id = category.proid.toString();
            const index = this.state.data.indexOf(id);
            if(selected) {
                // 요소추가
                if(index < 0) this.setState({data: [...this.state.data, id]});
            } else {
                // 요소제거
                if(index > -1) this.setState({data: this.state.data.filter((_, idx) => idx !== index) });
            }
        }
    }

    render() {
        return (
            <div className="popup-filter">
                <h2>
                    <span>채널 상세보기</span>
                    <PopupClose close={this.state.close} />
                </h2>
                <div className="popup-content">
                    <div className="theme">
                        <div className="list">
                            {
                                this.categories.slice(1).map((category, index) => {
                                    const id = category.proid.toString();
                                    return <CategoryTheme key={index + 1}
                                                          onChange={this.changeCategory}
                                                          category={category}
                                                          selected={this.state.data.includes(id)}
                                                          selectable={true} />;
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="popup-btn-wrap">
                    <span className="btn-m btn-s1" onClick={() => this.close(true)}>초기화</span>
                    <span className="btn-m btn-p1" onClick={() => this.close()}>필터 적용하기</span>
                </div>
            </div>
        );
    }
}

export default ThemeFilter;


// WEBPACK FOOTER //
// ./src/pages/components/popup/theme.filter.jsx